import { RoutePaths } from '@shared/utils';
import { Button, Icon, Text } from '@shared/widgets';
import ArrowIcon from '@assets/icons/arrow.svg';

interface PropsType {
  title: string | React.ReactNode;
  icon: React.ReactNode;
  url?: string;
  onClick?: () => void;
  buttonTitle?: string;
}

export const ConfirmModal = (props: PropsType) => {
  return (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50'>
      <div className='w-full max-w-[556px] h-full max-h-80 p-14 flex flex-col items-center justify-center bg-ice dark:bg-eerie-black shadow-lg'>
        <Icon icon={props.icon} className='flex justify-center mb-6' color='primary' />
        <Text className='mb-6 text-center' weight='semibold' size='2xl'>
          {props.title}
        </Text>
        <div className='flex justify-center'>
          <Button
            color='outlined'
            className='rounded'
            onClick={props.onClick}
            to={!props.onClick ? props.url || RoutePaths.payments.onNavigate() : undefined}
          >
            {props.buttonTitle || 'Back to the Payments page'} <Icon icon={<ArrowIcon />} color='inherit' />
          </Button>
        </div>
      </div>
    </div>
  );
};
